import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { SORT_CONFIGURATION } from '@/components/catalog/Catalog';
import type { QueryType } from '@/utils/query';

interface CatalogSortProps {
  sort: string[]
}

type CatalogSortEmits = {
  (event: 'onSortingChange', sort: { [key: string]: QueryType }): void
}


const ICON = 'icon-arrow-sort'

export default /*#__PURE__*/_defineComponent({
  __name: 'Catalog-Sort',
  props: {
  sort: null
},
  emits: ["onSortingChange"],
  setup(__props, { emit }) {

const props = __props;





const sortString = ref(props.sort[0].split(',')[0]);
const sortDirection = ref(props.sort[0].split(',')[1]);



const handleSortDirection = () => {
  sortDirection.value = sortDirection.value === 'ASC' ? 'DESC' : 'ASC';
};

watch(() => [sortString.value, sortDirection.value], () => {
  emit('onSortingChange', { sort: [`${sortString.value},${sortDirection.value}`] });
});

return { __sfc: true,ICON, props, emit, sortString, sortDirection, handleSortDirection, ref, watch, SORT_CONFIGURATION }
}

})